// src/services/api.js
import axios from 'axios';

const baseURL = process.env.REACT_APP_API_URL
if (!baseURL) {
  console.error('REACT_APP_API_URL is not defined');
}

const api = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true
});

api.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear any existing auth header
      delete api.defaults.headers.common['Authorization'];
      
      // Redirect to login if not already there
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject({
      message: error.response?.data?.message,
      status: error.response?.status,
      errors: error.response?.data?.errors,
      data: error.response?.data,
      response: error.response
    });
  }
);

export default api;